import { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import Iframe from "react-iframe";

import {
  Grid,
  Card,
  CardContent,
  CardActions,
  Typography,
  Box,
  Link,
  Button,
} from "@material-ui/core";

import { getContentStatus } from "../../consts/assignedContentStatus";
import { useStyles } from "./styles";

export const Resource = ({ data, assignedContent }) => {
  const classes = useStyles();
  const [isFrameOpen, setIsFrameOpen] = useState(false);

  const resourceTypes = useSelector((state) => state.content.resourceTypes);

  const getResourceType = useCallback(
    (resourceTypeId) => {
      const foundResourceType = resourceTypes.find(
        (resourceType) => resourceType.resourceTypeId === resourceTypeId
      );
      return foundResourceType?.name;
    },
    [resourceTypes]
  );

  const handleOpenResource = () => {
    setIsFrameOpen(true);
  };

  return (
    <Grid
      item
      xl={12}
      lg={12}
      md={12}
      sm={12}
      xs={12}
      className={classes.paper}
    >
      <Card className={classes.root}>
        <CardActions disableSpacing className={classes.cardHeader}>
          <Grid container>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography variant="subtitle1">{data.title}</Typography>
            </Grid>
          </Grid>
        </CardActions>
        <CardContent className={classes.cardContent}>
          <Box marginBottom={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography variant="subtitle2" align="left">
                Category
              </Typography>
            </Grid>
          </Box>
          <Box marginBottom={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography variant="body2" align="left">
                {data.categoryName}
              </Typography>
            </Grid>
          </Box>

          <Box marginBottom={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography variant="subtitle2" align="left">
                Type
              </Typography>
            </Grid>
          </Box>
          <Box marginBottom={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography variant="body2" align="left">
                {getResourceType(data.resourceTypeId)}
              </Typography>
            </Grid>
          </Box>

          <Box marginBottom={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography variant="subtitle2" align="left">
                Description
              </Typography>
            </Grid>
          </Box>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Typography variant="body2" align="left">
              {data.description}
            </Typography>
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{ textAlign: "right", paddingRight: "23px" }}
          >
            {assignedContent.statusId > 0 && (
              <Typography
                variant="caption"
                className={classes.assignedContent}
                component="span"
              >
                Status:&nbsp; {getContentStatus(assignedContent.statusId)}
              </Typography>
            )}
          </Grid>
        </CardContent>
        <CardActions className={classes.cardActions} disableSpacing>
          <Grid container>
            <Grid item lg={4} md={6} sm={6} xs={6}>
              {!data.isFrame && (
                <Link
                  className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-fullWidth"
                  underline="none"
                  data-testid="open-resource-btn"
                  href={
                    /^https?:\/\//.test(data.url)
                      ? data.url
                      : `http://${data.url}`
                  }
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Open Resource
                </Link>
              )}
              {data.isFrame && (
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={handleOpenResource}
                  data-testid="open-resource-btn"
                >
                  Open Resource
                </Button>
              )}
            </Grid>
            <Grid item lg={8} md={6} sm={6} xs={6}>
              <Box margin={1} />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              {isFrameOpen && (
                <Iframe
                  url={data.url}
                  width="100%"
                  height="450px"
                  className={classes.resourceFrame}
                  id="resource-iframe"
                />
              )}
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    </Grid>
  );
};

Resource.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    categoryName: PropTypes.string.isRequired,
    resourceTypeId: PropTypes.number,
    url: PropTypes.string,
    isFrame: PropTypes.bool,
  }),
  assignedContent: PropTypes.shape({
    statusId: PropTypes.number,
    assignedAt: PropTypes.string,
  }),
};

Resource.defaultProps = {
  data: {
    title: "",
    description: "",
    categoryName: "",
    resourceTypeId: 0,
    url: "",
  },
  assignedContent: {
    statusId: 0,
    assignedAt: null,
  },
};
